module.exports = __webpack_public_path__ + "static/img/hero@2x.80cfa52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero@2x.png
// module id = eyWS
// module chunks = 1